import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { compareState } from "../../store/CompareState";
import { useRecoilState } from "recoil";
import RetryableImage from "../retryableImage/RetryableImage";
const TableContainer = styled.div`
  width: 100%; /* Keep the container width 100% */
`;
const TableWrapper = styled.div`
  box-sizing: border-box; /* Include padding/border in the element's total width */
`;

const StyledTable = styled.table`
  width: 100%;
  text-align: left;
  table-layout: fixed; /* Ensures uniform column widths */
`;

const TableCell = styled.td`
  padding: 10px;
  font-size: small; /* Ensures a minimum width for each column */
  padding-right: 0px;
`;

const TableHeader = styled.th`
  background-color: #f4f4f4;
  padding-left: 10px; /* Light background for header */
  font-size: 13px;
`;

const Checkbox = styled.input.attrs({ type: "checkbox" })`
  margin-right: 5px;
`;

const ProductLink = styled(NavLink)`
  text-decoration: none;
  color: inherit;
`;

const ProductIdCell = styled(TableCell)`
  color: rgb(35, 4, 130); /* Optional: change the text color for better contrast */
  text-decoration: none;
   width: 200px !important;
`;

const ShowMoreButton = styled.button`
  margin-top: 10px;
  padding: 8px 16px;
  background-color: #f4f4f4;
  color: black;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100%; /* Full-width button */
  text-align: center; /* Center text */

  &:hover {
    background-color: #f1f1f1;
  }
`;

const TableRow = styled.tr`
border-bottom:1px solid rgb(216, 214, 214);
  
`;

const ListView = ({ categoryName, products, tableViewColumns }) => {
  console.log("products in listView", products);
  console.log("tableViewColumns in listView", tableViewColumns);
  console.log("categoryName in listView", categoryName);
  // const { addToCompare, removeFromCompare,compareList, clearCompareList } = useCompare();
  const [compareProducts, setCompareProducts] = useRecoilState(compareState);
  const [selectedProducts, setSelectedProducts] = useState({}); // Track selected products
  const [visibleCount, setVisibleCount] = useState(10); // Manage the visible items count

  const handleCompareToggle = (product) => {
    const isSelected = !!selectedProducts[product.productId];
    const updatedSelectedProducts = { ...selectedProducts };

    if (isSelected) {
      delete updatedSelectedProducts[product.productId]; // Remove from selected
      removeFromCompare(product.productId); // Remove from compare list
    } else {
      // updatedSelectedProducts[product.productId] = product; // Add to selected
      // addToCompare(product); // Add to compare list
      if (compareProducts.length < window.ENV.COMPARE_TOTAL_ITEM) {
        updatedSelectedProducts[product.productId] = product;
        addToCompare(product);
      } else {
        alert("You can only compare up to ${window.ENV.COMPARE_TOTAL_ITEM} products.");
        return;
      }
    }

    setSelectedProducts(updatedSelectedProducts);
  };

  // const isCompareDisabled = compareList.length >= 4;

  const handleShowMore = () => {
    setVisibleCount(products.length); // Show all products
  };

  const addToCompare = (product) => {
    if (compareProducts.length < window.ENV.COMPARE_TOTAL_ITEM) {
      setCompareProducts((prev) => [...prev, product]);
    } else {
      alert("You can only compare up to ${window.ENV.COMPARE_TOTAL_ITEM} products.");
    }
  };

  // Remove product from compare list
  const removeFromCompare = (productId) => {
    setCompareProducts((prev) => prev.filter((item) => item.productId !== productId));
  };

  useEffect(() => {
    const updatedSelectedProducts = {};
    compareProducts.forEach((item) => {
      updatedSelectedProducts[item.productId] = item; // Mark the products in the compare list as selected
    });
    setSelectedProducts(updatedSelectedProducts); // Update the selected products state
  }, [compareProducts]); // Dependency on compareList

  // Helper to get the first 7 non-empty PRODUCT_LIST_ITEMS fields for the first product
  const getFirst7Fields = () => {
    if (!products || products.length === 0) return [];
    return window.ENV.PRODUCT_LIST_ITEMS
      .filter(item => {
        const val = products[0][item.VALUE];

        return val !== null && val !== undefined && val !== "";
      })
      .slice(0, 5);
  };

  // Helper to get columns from tableViewColumns (spreadsheet) or fallback
  const getColumns = () => {
    console.log("getColumns");
    if (
      window.ENV.PRODUCT_LIST_TABLE_VIEW_COLUMNS_FROM_SHEET
    ) {
      // Parse comma-separated string, trim, and map to PRODUCT_LIST_ITEMS for label/value
      console.log("tableViewColumns", tableViewColumns);
      const keys = tableViewColumns?.split(',').map(k => k.trim()).filter(Boolean);
      console.log("keys in getColumns:", keys);
      // Map to PRODUCT_LIST_ITEMS for label/value, fallback to {LABEL: key, VALUE: key} if not found
      return keys.map(key => {
        const found = window.ENV.PRODUCT_LIST_ITEMS.find(item => item.VALUE === key);
        return found || { LABEL: key, VALUE: key };
      });
    }
    // Fallback to first 7 non-empty fields
    return getFirst7Fields();
  };

  const columns = getColumns();

  console.log("products of items", products[0]["2d_drawing"]);
  return (
    <TableContainer>
      <TableWrapper>
        <StyledTable>
          <colgroup>
            {/* Product column (ProductIdCell) with fixed width */}
            <col style={{ width: "100px" }} />
            {/* Image column */}
            <col style={{ width: "100px" }} />
            {/* Description column */}
            {(window.ENV.PRODUCT_LIST_TABLE_SHOW_DESCRIPTION || typeof window.ENV.PRODUCT_LIST_TABLE_SHOW_DESCRIPTION === "undefined") && (
              <col style={{ width: "100px" }} />
            )}
            {/* Dynamic columns */}
            {columns.map((item, idx) => (
              <col key={idx} style={{ width: "120px" }} />
            ))}
          </colgroup>
          <thead>
            <tr>
              <TableHeader>Image</TableHeader>
              <TableHeader>Product</TableHeader>

              {(window.ENV.PRODUCT_LIST_TABLE_SHOW_DESCRIPTION || typeof window.ENV.PRODUCT_LIST_TABLE_SHOW_DESCRIPTION === "undefined") && (
                <TableHeader>Description</TableHeader>
              )}

              {columns.map((item, idx) => (
                <TableHeader key={idx}>{item.LABEL}</TableHeader>
              ))}
            </tr>
          </thead>
          <tbody>
            {products.slice(0, visibleCount).map((product) => {
              const isSelected = !!selectedProducts[product.productId];
              const isCompareDisabled = compareProducts.length >= window.ENV.COMPARE_TOTAL_ITEM && !isSelected;
              return (
                <TableRow key={product.productId}>
                  <TableCell>

                    {/* <img
                      src={`${window.ENV.SERVER_URL}${product.isometric_view}`}
                      alt={`${product.Label} Isometric View`}
                      style={{ width: "80px", height: "80px", objectFit: "contain" }}
                    /> */}

                    <RetryableImage
                    src={`${window.ENV.SERVER_URL}${product.isometric_view}`}
                    alt={`${product.Label} Isometric View`}
                    style={{ width: "80px", height: "80px", objectFit: "contain" }}
                    maxRetries={window.ENV.MAX_RETRIES || 10}
                    retryDelay={window.ENV.RETRY_DELAY || 5000}/>


                  </TableCell>
                  {/* <ProductIdCell width="150px"> */}
                  <TableCell>
                    {window.ENV.SHOW_COMPARE && (

                      <Checkbox
                        checked={isSelected}
                        onChange={() => handleCompareToggle(product)}
                        disabled={isCompareDisabled}
                      />)}
                    <ProductLink
                      to={`/category/${categoryName}/productdetails/${product.productId}`}
                      state={{ productlabel: product.Label }}
                    >
                      {product.productId}
                    </ProductLink>
                  </TableCell>
                  {/* </ProductIdCell> */}

                  {(window.ENV.PRODUCT_LIST_TABLE_SHOW_DESCRIPTION || typeof window.ENV.PRODUCT_LIST_TABLE_SHOW_DESCRIPTION === "undefined") && (
                    <TableCell>{product.description}</TableCell>
                  )}

                  {columns.map((item, idx) => (
                    <TableCell key={idx}>{product[item.VALUE]}</TableCell>
                  ))}
                </TableRow>
              );
            })}
          </tbody>

        </StyledTable>
        {visibleCount < products.length && (
          <ShowMoreButton onClick={handleShowMore}>Show More</ShowMoreButton>
        )}
      </TableWrapper>
    </TableContainer>
  );
};

export default ListView;
